module.exports = __webpack_public_path__ + "img/empty.336ff3e2.png";